var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_26061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41094 3.4724C8.41094 2.81474 8.41094 2.48591 8.30369 2.22694C8.23276 2.0556 8.12876 1.89991 7.99763 1.76878C7.8665 1.63765 7.71082 1.53365 7.53947 1.46273C7.2805 1.35547 6.95167 1.35547 6.29401 1.35547H4.17707C2.84623 1.35547 2.18151 1.35547 1.768 1.76898C1.35449 2.18248 1.35449 2.8472 1.35449 4.17805V6.29498C1.35449 6.95265 1.35449 7.28148 1.46175 7.54045C1.53268 7.71179 1.63668 7.86748 1.76781 7.99861C1.89893 8.12974 2.05462 8.23374 2.22596 8.30466C2.48494 8.41192 2.81377 8.41192 3.47143 8.41192",
    stroke: "#0D2D44",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2331 5.58984H6.99918C6.21975 5.58984 5.58789 6.2217 5.58789 7.00113V11.235C5.58789 12.0144 6.21975 12.6463 6.99918 12.6463H11.2331C12.0125 12.6463 12.6443 12.0144 12.6443 11.235V7.00113C12.6443 6.2217 12.0125 5.58984 11.2331 5.58984Z",
    stroke: "#0D2D44",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_26061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copy-blue.8430b898415b0b70c3b3a5e8f70b9463.svg";
export { ForwardRef as ReactComponent };